import { render } from "./ViewCardNews.vue?vue&type=template&id=5a101d75&scoped=true"
import script from "./ViewCardNews.vue?vue&type=script&lang=js"
export * from "./ViewCardNews.vue?vue&type=script&lang=js"

import "./ViewCardNews.vue?vue&type=style&index=0&id=5a101d75&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a101d75"]])

export default __exports__